

export default {
  name: 'Item',
  components: {},
  props: {
    icon: String,
    title: String,
    num: [String, Number],
    collapse: Boolean,
    count: [String, Number]
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {}
};